import DOMPurify from 'dompurify';

/**
 * Sanitize email HTML before we render it. BUILD_STANDARDS §8 blocker:
 * inbound reply HTML is attacker-controlled and gets rendered in the
 * operator's browser via dangerouslySetInnerHTML. DOMPurify strips
 * everything not in the allowlist so <script>, on* handlers,
 * javascript: URLs, and <iframe>/<object>/<style> can't sneak through.
 */
const CONFIG = {
  ALLOWED_TAGS: [
    'a', 'b', 'blockquote', 'br', 'div', 'em', 'h1', 'h2', 'h3', 'h4',
    'h5', 'h6', 'hr', 'i', 'img', 'li', 'ol', 'p', 'pre', 'small', 'span',
    'strong', 'table', 'tbody', 'td', 'th', 'thead', 'tr', 'u', 'ul',
  ],
  ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'target', 'rel', 'width', 'height'],
  ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|cid):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'style', 'meta', 'link'],
  FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'formaction'],
  ADD_ATTR: ['target'],
  ALLOW_DATA_ATTR: false,
};

export function sanitizeEmailHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, CONFIG);
  return typeof clean === 'string' ? clean : String(clean);
}
